import { useFetch } from "./useFetch";
import { z } from "zod";

const ExchangeRateResponseSchema = z.object({
  message: z.string(),
  data: z.object({
    base_currency: z.string(),
    target_currency: z.string(),
    rate: z.number(),
  }),
});

export type ExchangeRateResponse = z.infer<typeof ExchangeRateResponseSchema>;

export function useExchangeRate(fromCurrency: string, toCurrency: string, enabled = true) {
  return useFetch<ExchangeRateResponse>({
    queryKey: ["exchange", "rates", fromCurrency, toCurrency],
    url: `/wallet/exchange/rates?fromCurrency=${fromCurrency}&toCurrency=${toCurrency}`,
    schema: ExchangeRateResponseSchema,
    enabled,
    baseURL: "/api/proxy",
  });
}
